import { useState, useCallback, useEffect } from "react";
import { request } from "./../../httpClient/request";

export const useGetFavorite = () => {
  const [favoriteList, setFavoriteList] = useState<any>([]);
  const [favoriteLoading, setFavoriteLoading] = useState<boolean>(false);

  const getFavorite = useCallback(async () => {
    try {
      setFavoriteLoading(true);
      const res = await request({
        path: "vehicle-favorite/list",
      });
      setFavoriteList(res.data);
      setFavoriteLoading(false);
      return res;
    } catch (e) {
      alert(e);
      setFavoriteList([]);
      setFavoriteLoading(false);
    }
  }, []);

  useEffect(() => {
    getFavorite();
  }, []);

  return { favoriteList, getFavorite, favoriteLoading };
};
